export default {"src":"/_next/static/media/deco_ticketz_benefit_multiplier.fce7b2d9.svg","height":24,"width":33,"blurWidth":0,"blurHeight":0};